/*
 * Copyright (c) 2021. American Express Company
 */

/* eslint-disable */

export const NumberFormatters: { [key: string]: Intl.NumberFormat } = {
    detailedDollars: Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
};

Number.prototype.isPositive = function (): boolean {
    return this >= 0;
};

// converts a number to a currency string in dollars, with up to 2 decimals: $12,345.67
Number.prototype.toDetailedDollarsString = function (): string {
    let amount: number = this as number;
    if (isNaN(amount) || amount === 0) amount = 0;
    return NumberFormatters.detailedDollars.format(amount);
};

Number.prototype.toPercentString = function (digits: number = 2): string {
    return this.toFixed(digits) + '%';
};

export {}; // forces the file to be modular
